export default "__VITE_ASSET__Brms1ayz__"